package fr.arcplex.sooner.webui

import fr.arcplex.network.model.Rail
import fr.arcplex.network.model.RailItem

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import fr.arcplex.sooner.coherence.CoherenceThemeState
import fr.arcplex.sooner.coherence.coherenceNavFrom
import fr.arcplex.network.logging.Logger
import fr.arcplex.sooner.ui.theme.TVBackground
import fr.arcplex.sooner.ui.theme.TVLine
import fr.arcplex.sooner.ui.theme.TVMuted
import fr.arcplex.sooner.ui.theme.TVTxt

/**
 * Burger menu for the Coherence UI. Same panel as [MenuView], but every color,
 * radius and padding comes from the fetched Coherence theme instead of the
 * hardcoded TV* palette.
 */
@Composable
fun CoherenceMenuView(
    menu: Rail,
    isOpen: Boolean,
    onDismiss: () -> Unit,
    onItemClicked: (RailItem) -> Unit,
    isTV: Boolean,
    modifier: Modifier = Modifier
) {
    val nav = remember(menu) { coherenceNavFrom(menu) } ?: return
    val style = coherenceMenuStyle()

    Logger.d("COH-MENU", "menu title='${nav.title}' items=${nav.items.size} open=$isOpen isTV=$isTV")

    MenuPanel(
        nav = nav,
        style = style,
        isOpen = isOpen,
        onDismiss = onDismiss,
        onItemClicked = { entry ->
            menu.items.firstOrNull { it.uid == entry.uid }?.let(onItemClicked)
        },
        isTV = isTV,
        modifier = modifier
    )
}

@Composable
private fun coherenceMenuStyle(): MenuStyle {
    val theme = CoherenceThemeState.theme
    val page = theme.page
    val action = theme.kinds.action

    val background =
        parseHexColorOrNull(page.surface) ?: parseHexColorOrNull(page.background) ?: TVBackground
    val border = parseHexColorOrNull(action.borderColor) ?: TVLine
    val text = parseHexColorOrNull(page.text) ?: TVTxt
    val muted = parseHexColorOrNull(page.muted) ?: TVMuted
    val accent = parseHexColorOrNull(page.accent) ?: Color.White
    val pageBackground = parseHexColorOrNull(page.background) ?: Color.Black

    return MenuStyle(
        background = background,
        border = border,
        titleColor = muted,
        separatorColor = border.copy(alpha = 0.4f),
        itemColor = text,
        focusBackground = accent,
        focusColor = pageBackground,
        focusBorder = accent,
        titleSize = (theme.kinds.rail.titleSize ?: 15).sp,
        itemSize = (theme.kinds.text.size ?: 17).sp,
        itemPaddingX = (action.paddingX ?: 14).dp,
        itemPaddingY = (action.paddingY ?: 6).dp,
        cornerRadius = (action.radius ?: 5).dp
    )
}
